"use client";

import { useMutation } from "@tanstack/react-query";
import log from "logbeacon";
import { safeStringifyError } from "utils";
import { useOspApiClientProvider } from "@/src/hooks";
import type { ActivateGoalResponse } from "@/src/features/api/ChatApi";

/**
 * POST /goals/{goalId}/activate — PLANNED → ACTIVE（第二次 Paywall 成功后）。
 */
export const useActivateGoal = () => {
  const { chatApi } = useOspApiClientProvider();

  return useMutation({
    mutationFn: async (goalId: string): Promise<ActivateGoalResponse> => {
      const trimmed = goalId.trim();
      if (!trimmed) {
        throw new Error("[useActivateGoal] goalId is required");
      }

      if (!chatApi?.goals) {
        throw new Error("[useActivateGoal] chatApi.goals unavailable");
      }

      log.info("[useActivateGoal] activate request", { goalId: trimmed });
      const res = await chatApi.goals.activateCreate(trimmed);

      if (res?.error) {
        log.warn(
          "[useActivateGoal] activate failed",
          safeStringifyError(res.error),
        );
        throw res.error;
      }

      return (
        res.data ?? {
          goalId: trimmed,
          status: "ACTIVE",
        }
      );
    },
  });
};
